import { jsx as r } from "react/jsx-runtime";
import { DuckDBConnectionProvider as c } from "./connectionProvider.js";
import { DuckDBBaseProvider as D } from "./databaseProvider.js";
import { DuckDBPlatform as n } from "./platformProvider.js";
const B = ({
  logger: o,
  children: i,
  bundles: e,
  enableProgress: m,
  config: t
}) => /* @__PURE__ */ r(n, { logger: o, bundles: e, children: /* @__PURE__ */ r(D, { config: t, enableProgress: m, children: /* @__PURE__ */ r(c, { children: i }) }) });
export {
  B as DuckDBProvider
};
